import { render, staticRenderFns } from "./CoreSidebar.vue?vue&type=template&id=42f23094&"
import script from "./CoreSidebar.vue?vue&type=script&lang=js&"
export * from "./CoreSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CoreSidebar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports